<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>El desembarco de Cortés en 1519</h2>
    <img @click="imageClicked(0)" src="galerias/tenochtitlan/g2/g2.jpg" class="mainphoto"/>
    <p class="photo-description">Imagen tomada del libro “Historia de las Indias de Nueva España e islas de la tierra firme”. Manuscrito en papel europeo elaborado por Fray Diego Durán, 1579. Col. Biblioteca Nacional de España.</p>
    <p>La isla de Cuba fue un punto importante en el proceso de conquista española. Su gobernador, Diego Velázquez, nombró a Hernán Cortés capitán general de la nueva expedición el 23 de octubre de 1518. Sin embargo, Velázquez le perdió muy rápido la confianza a Cortés y lo mandó a detener.</p>
    <p>Esto no lo frenó y el 10 de febrero de 1519 Hernán Cortés salió de Cuba con 11 navíos. 17 días después llegó a la Isla de Cozumel. Continuaría su trayecto por todo el Golfo de México pasando por Yucatán, Tabasco, y finalmente Cempoala, en Veracruz, donde contactó a la comitiva enviada por Moctezuma.</p>
    <p>Desde el desembarco en Cozumel, la expedición tocó diferentes puntos de la actual costa del Golfo de México, bordeando la Península de Yucatán, llegando a Centla, Tabasco, hasta que se llegó a fundar, el 22 de abril de 1519, la Villa Rica de la Vera Cruz, en Chalchicuecan, muy cerca de la ciudad actual con este nombre.</p>
    <p>El 18 de junio de 1519, en Cempoala, ciudad totonaca, Cortés tuvo contacto por primera vez con el grupo enviado por Moctezuma, quienes le entregaron regalos que fueron enviados a España.</p>
    <h5>VER MÁS</h5>
    <p>Aquí puedes ver el códice completo: 
      <ul>
        <li><a target="_blank" href="http://bdh-rd.bne.es/viewer.vm?id=0000169486&page=1">bdh-rd.bne.es</a></li>
      </ul>
    </p>
    <h4>El naufragio de Jerónimo de Aguilar y Gonzalo Guerrero</h4>
    <img @click="imageClicked(1)" src="galerias/tenochtitlan/g2/G2_a.jpg" class="mainphoto"/>
    <p class="photo-description">Imagen tomada del libro “Historia de la Conquista de México” Antonio de Solís y Rivadeneira. Grabado. Col. Fondo Antiguo de la Biblioteca de la Universidad de Sevilla</p>
    <p>Jerónimo de Aguilar y Gonzalo Guerrero fueron náufragos españoles que vivieron por 8 años en la península de Yucatán hasta el desembarco de Cortés en la isla de Cozumel en 1519.</p>
    <p>Jerónimo de Aguilar se unió a las huestes de Cortés como traductor, mientras que Gonzalo Guerrero se negó a formar parte de ellas, para permanecer con su familia maya siendo considerado el padre del mestizaje, y combatió contra los españoles.</p>
    <p>Para saber más, visita el siguiente link: 
      <ul>
        <li><a target="_blank" href="http://dbe.rah.es/biografias/5343/jeronimo-de-aguilar">dbe.rah.es</a></li>
      </ul>
    </p>
    <h4>Hernán Cortés</h4>
    <img @click="imageClicked(2)" src="galerias/tenochtitlan/g2/G2_b.jpg" class="mainphoto"/>
    <p class="photo-description">Imagen tomada del libro “Historia de la Conquista de México” Antonio de Solís y Rivadeneira</p>
    <p>El desarrollo y detalles de la expedición de Cortés lo conocemos gracias a las llamadas “Cartas de Relación” que él mismo escribió. Si bien, el tono de la narrativa está dirigida a exaltar su labor como conquistador en nombre del rey, las cinco cartas nos permiten conocer detalles y elementos fundamentales para acercarnos a la construcción histórica y a la narrativa de la conquista a partir de su información. La primera de las cartas no se conoce, la segunda fue firmada el 30 de octubre de 1520 en Segura de la Frontera, hoy Tepeaca, Puebla. La tercera fue elaborada en Coyoacán el 15 de mayo de 1522. La cuarta carta de relación es del 15 de octubre de 1524 y fue redactada en Tenochtitlan. La última, está redactada cuando Cortés regresa de la expedición a Las Hibueras, hoy Honduras, el 3 de septiembre de 1526.</p>
    <p>La segunda, tercera y cuarta carta circularon impresas, por lo que fueron una fuente de información que durante mucho tiempo se utilizó para construir la historia de la conquista y fomentaron la imagen heroica de Cortés como el gran conquistador de México.</p>
    <p>Ver más</p>
    <p>Fuente del grabado
      <ul>
        <li><a target="_blank" href="https://books.google.com.do/books?id=nDpAAAAAcAAJ&printsec=frontcover#v=thumbnail&q&f=false">books.google.com.do</a></li>
        <li><a target="_blank" href="http://www.cervantesvirtual.com/obra/historia-de-nueva-espana-986137/">www.cervantesvirtual.com</a></li>
      </ul>
    </p>
  </div>
</template>

<script>
export default {
  name: "Sala1m2",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    },
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
